import ENDPOINT from "@/api/endpoints";
import { HTTP } from "@/api/http-common";

export function callApiSearchDonViNgoai(payload) {
  return HTTP({
    url: ENDPOINT.DON_VI_NGOAI.SEARCH,
    method: "GET",
    params: payload,
  });
}

export function callApiGetMultiDonViNgoai(payload) {
  return HTTP({
    url: ENDPOINT.DON_VI_NGOAI.GET_MULTI,
    method: "POST",
    data: payload,
  });
}

export function callApiGetDonViNgoaiIgnore(payload) {
  return HTTP({
    url: ENDPOINT.DON_VI_NGOAI.SEARCH_IGNORE,
    method: "POST",
    data: payload,
  });
}
